import { useSSRSelector } from 'src/redux/ssrStore';
import { getIcons, HIGH_GAP_TYPE } from './SocialMediaUtils';

const SocialMediaIcons = (props: any) => {
  const {
    componentData: { selectedType },
    activeFooterData,
  } = props;
  const footerConfig = activeFooterData?.footerPropsConfig?.footerConfig;
  const color =
    footerConfig?.colorSchemes?.[footerConfig?.selectedColorSchemeIndex]?.text;
  const store = useSSRSelector((state) => state.storeReducer.store);
  const socialMediaDetail = store.social_media_profile_details?.media_detail;
  return (
    <div className={`tw-flex tw-cursor-pointer tw-flex-wrap tw-items-center ${HIGH_GAP_TYPE?.includes(selectedType) ? 'tw-gap-[24px]' : 'tw-gap-[16px]'}`}>
      {socialMediaDetail?.map((data, index) => {
        const iconDetails = getIcons(selectedType, data?.name, color);
        return (
          data?.profile_url &&
          (iconDetails ? (
            <a href={data.profile_url} target="_blank" rel="noreferrer">
              {iconDetails}
            </a>
          ) : (
            <a href={data.profile_url} target="_blank" rel="noreferrer">
              <img
                src={data.image_url}
                alt={`${data?.name} image`}
                loading="lazy"
                style={{ width: '28px' }}
              />
            </a>
          ))
        );
      })}
    </div>
  );
};

export default SocialMediaIcons;
